import { ThemeContext } from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var MockTheme = function MockTheme(_ref) {
  var children = _ref.children,
    theme = _ref.theme;
  return /*#__PURE__*/jsx(ThemeContext.Provider, {
    value: theme,
    children: children
  });
};
MockTheme.displayName = "MockTheme";

export { MockTheme };
